import React, { useMemo, useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import { InputWithAdminSearch, TextareaField } from '../../../../utils/InputField';
import { CrossIcon } from '../../../../utils/SVGIcon';
import { ApiMakeDoneItem } from '../ServicesManageOperation';

function MakeDoneModal({ data, handleReload }) {
    const { setMessage, setConfirm } = useTemplate();
    const [loading, setLoading] = useState(false);
    const [selectedAdmin, setSelectedAdmin] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [isError, setIsError] = useState('');
    const [formData, setFormData] = useState({
        ServiceId: data?.id,
        Admins: [],
        Note: ''
    });
    const payload = useMemo(() => {
        return {
            ServiceId: data?.id,
            Members: selectedAdmin.map((item) => item.id),
            Note: formData.Note
        };
    }, [formData, selectedAdmin, data]);
    // -- Handle Form Data
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };
    const handleSelectAdmin = (e) => {
        const { value } = e.target;
        // -- Check if the admin is already selected
        if (selectedAdmin.find((item) => item.id === value.id)) {
            setErrorMessage('Admin already selected');
        } else {
            setSelectedAdmin((prev) => [...prev, { id: value.id, name: value.fullName }]);
        }
    };
    // -- Handle Form Submit
    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        ApiMakeDoneItem(data?.id, payload, setIsError)
            .then(({ title }) => {
                setMessage({ type: 'success', text: title });
                setConfirm(null);
                handleReload();
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                setMessage({ type: 'error', text: err.toString(0) });
            });
    };
    // automatic remove after 3s
    if (errorMessage) {
        setTimeout(() => {
            setErrorMessage('');
        }, 4000);
    }
    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleSubmit} className="w-full flex flex-col gap-2">
            <p className="text-base font-normal md:whitespace-nowrap">
                Are you sure you want to make this service done ??
            </p>
            <InputWithAdminSearch
                name="Members"
                formData={formData}
                onChange={handleSelectAdmin}
                label="Select Member (optional)"
                placeholder="Type Name, Email or Phone"
            />
            <div className="flex flex-wrap gap-2">
                {selectedAdmin &&
                    selectedAdmin.map((item) => (
                        <p
                            key={item.id}
                            className="flex gap-2 bg-primary-100 px-1.5 py-0.5 rounded-5"
                        >
                            <span> {item.name}</span>
                            <button
                                type="button"
                                onClick={() =>
                                    setSelectedAdmin((prev) => prev.filter((i) => i.id !== item.id))
                                }
                                className="text-error"
                            >
                                <CrossIcon />
                            </button>
                        </p>
                    ))}
            </div>
            <TextareaField
                name="Note"
                label="Notes"
                placeholder="Write your notes....."
                formData={formData}
                onChange={handleChange}
                className="h-20 *:resize-none"
                required
            />
            <p className="text-error text-xs text-left ">{errorMessage}</p>
            <div className="w-full flex justify-end items-center gap-2">
                <ButtonCancel title="Cancel" onClick={() => setConfirm(null)} />
                <ButtonPrimary title="Save" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default MakeDoneModal;
